export default __webpack_public_path__ + "70a92e9fec87cb4d4f269fb5c13c87d8.png";